import React from "react";

type Props = {
  children: React.ReactNode;
};

export function TodoClickToReveal({ children }: Props) {
  // TODO: click to reveal — mask sensitive values (email, phone) and reveal
  // them only when the operator clicks. For now this renders the value as-is.
  return <>{children}</>;
}
